<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
    >
      <a-form-model-item label="省份" prop="provinceCode">
        <a-select
          v-model="formData.provinceCode"
          placeholder="请选择省份"
          allow-clear
          @change="handleProvinceChange"
        >
          <a-select-option
            v-for="item in provinceList"
            :value="item.code"
            :key="item.code"
            >{{ item.descript }}({{ item.code }})</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="城市" prop="cityCode">
        <a-select
          v-model="formData.cityCode"
          placeholder="请选择城市"
          allow-clear
          @change="handleCityChange"
        >
          <a-select-option
            v-for="item in tmpCityList"
            :value="item.code"
            :key="item.code"
            >{{ item.descript }}({{ item.code }})</a-select-option
          >
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="区域" prop="districtCode">
        <a-select
          v-model="formData.districtCode"
          placeholder="请选择区域"
          allow-clear
        >
          <a-select-option
            v-for="item in tmpDistrictList"
            :value="item.code"
            :key="item.code"
            >{{ item.descript }}({{ item.code }})</a-select-option
          >
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="商圈名称" prop="descript"
        ><a-input v-model="formData.descript" :maxLength="20"
      /></a-form-model-item>
      <a-form-model-item label="商圈代码" prop="code"
        ><a-input
          v-model="formData.code"
          :maxLength="20"
          :disabled="modal.type == 'add' ? false : true"
      /></a-form-model-item>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "CircleInfo",
  props: {
    provinceList: {
      type: Array,
      default() {
        return [];
      }
    },
    cityList: {
      type: Array,
      default() {
        return [];
      }
    },
    districtList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      confirmLoading: false,
      tmpCityList: [],
      tmpDistrictList: [],
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        countryCode: "China",
        provinceCode: "",
        cityCode: "",
        districtCode: "",
        descript: "",
        code: "",
        isHalt: "F"
      },
      //form rules
      rules: {
        provinceCode: [
          {
            required: true,
            message: "请输选择省份",
            trigger: "change"
          }
        ],
        cityCode: [
          {
            required: true,
            message: "请输选择城市",
            trigger: "change"
          }
        ],
        districtCode: [
          {
            required: true,
            message: "请输选择区域",
            trigger: "change"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入商圈代码",
            trigger: "change"
          }
        ],
        descript: [
          {
            required: true,
            message: "请输入商圈名称",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加商圈" : "编辑商圈";
      this.modal.type = type;
      if (data) {
        this.formData = Object.assign({}, data);
        this.handleProvinceChange(this.formData.provinceCode);
        this.handleCityChange(this.formData.cityCode);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    handleProvinceChange(value) {
      for (let p of this.provinceList) {
        if (p.code == value) {
          this.formData.countryCode = p.countryCode;
          break;
        }
      }
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    },
    handleCityChange(value) {
      let arr = [];
      for (let district of this.districtList) {
        if (district.cityCode == value) {
          arr.push(district);
        }
      }
      this.tmpDistrictList = arr;
    },
    cancel() {
      // this.formData = {};
      // this.$refs.ruleForm.resetFields();
      this.confirmLoading = false;
      this.modal.visible = false;
      this.formData.descript = "";
      this.formData.code = "";
      this.formData.isHalt = "F";
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveCodeCircle";
          if (this.modal.type == "edit") {
            action = "modifyCodeCircle";
          }
          this.$http.systemBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>
